export function ErrorFallback() {
  return (
    <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <h1 className="font-mono text-2xl font-bold mb-4">Something went wrong</h1>
        <p className="text-neutral-400 mb-6">
          We've been notified and are looking into it. Please try refreshing the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-3 bg-orange-500 hover:bg-orange-400 text-black font-semibold rounded-lg transition-colors"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}
